import { useCallback } from 'react';

import { client } from '../../../api/rest/client';
import { Actions } from '../../../constants/actionTypes';
import { toastErrorTranslated } from '../../../helpers/toast';
import { useMainDispatch } from '../../useMainDispatch';

export const useTimezoneActions = () => {
  const dispatch = useMainDispatch();

  const getAndSetTimezone = useCallback(async () => {
    try {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
      const {
        data: { timezone },
      } = await client.bot.getTimezoneConfig();
      dispatch({ type: Actions.SET_TIMEZONE, payload: timezone });
    } catch (error) {
      console.error(error);
      toastErrorTranslated(error);
    } finally {
      dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
    }
  }, [dispatch]);

  const updateTimezone = useCallback(
    async (timezone: string) => {
      try {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: true } });
        await client.bot.updateTimezoneConfig({ body: { timezone } });
        dispatch({ type: Actions.SET_TIMEZONE, payload: timezone });
      } catch (error) {
        console.error(error);
        toastErrorTranslated(error);
      } finally {
        dispatch({ type: Actions.SET_UI, payload: { isLoading: false } });
      }
    },
    [dispatch],
  );

  return {
    getAndSetTimezone,
    updateTimezone,
  };
};
